'use client'
import { useCallback, useEffect, useState } from "react";
const useCarouselDotButton = (emblaApi)=>{
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [scrollSnaps, setScrollSnaps] = useState([]);
    const onDotButtonClick = useCallback((index, event)=>{
        if (event) event.stopPropagation();
        if (!emblaApi) return;
        emblaApi.scrollTo(index);
    }, [
        emblaApi
    ]);
    const onInit = useCallback((emblaApi)=>{
        setScrollSnaps(emblaApi.scrollSnapList());
    }, []);
    const onSelect = useCallback((emblaApi)=>{
        setSelectedIndex(emblaApi.selectedScrollSnap());
    }, []);
    useEffect(()=>{
        if (!emblaApi) return;
        onInit(emblaApi);
        onSelect(emblaApi);
        emblaApi.on('reInit', onInit).on('reInit', onSelect).on('select', onSelect);
    }, [
        emblaApi,
        onInit,
        onSelect
    ]);
    return {
        selectedIndex,
        scrollSnaps,
        onDotButtonClick
    };
};
export { useCarouselDotButton };
